import React, { useState, useEffect, useContext } from "react";
import ScreenshotGallery from "../../mycomp/Dashboard/Hotel/ScreenshotGallery";
import { fetchOrganizationScreenshots } from "../../api/api";
import { AuthContext } from "../../context/AuthContext";

const Screenshots = () => {
  const { user } = useContext(AuthContext);
  const [screenshots, setScreenshots] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { 
    if (!user?.organization_id) return;

    const loadScreenshots = async () => {
      try {
        setLoading(true);
        const data = await fetchOrganizationScreenshots(user.organization_id);
        // `data` is already an array
        setScreenshots(data); 
      } catch (err) {
        console.error("Failed to fetch screenshots:", err);
      } finally {
        setLoading(false);
      }
    };

    loadScreenshots();
  }, [user]);

  if (loading) return <div>Loading screenshots…</div>;

  return <ScreenshotGallery screenshots={screenshots} />;
};

export default Screenshots;